var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4Z",
    transform: "translate(8.27832 8.2793)",
    fill: "#F7931E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4Z",
    transform: "translate(14.1387 13.9805)",
    fill: "#F7931E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57835 0C11.718 0.0199205 13.7881 0.762325 15.4527 2.10673C17.1173 3.45113 18.2787 5.31862 18.7485 7.40613C19.2182 9.49363 18.9687 11.6786 18.0405 13.6065C17.1123 15.5344 15.5597 17.092 13.6349 18.0266C11.7101 18.9611 9.52593 19.2178 7.43689 18.7548C5.34786 18.2919 3.47657 17.1366 2.12672 15.4764C0.77687 13.8162 0.0276851 11.7486 0.000752326 9.60904C-0.0261804 7.4695 0.67072 5.38365 1.97835 3.69",
    transform: "translate(3 3)",
    stroke: "#1E334E",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.05514 1.85006C2.05232 1.89394 2.03698 1.93609 2.01093 1.97152C1.98488 2.00695 1.94923 2.03418 1.90818 2.04996C1.86714 2.06575 1.82243 2.06944 1.77936 2.06059C1.73628 2.05175 1.69665 2.03074 1.66514 2.00006L0.865144 1.20006L0.0751439 0.400058C0.040508 0.368518 0.0163285 0.327154 0.00583966 0.281499C-0.00464916 0.235844 -0.000947127 0.188074 0.0164505 0.14458C0.0338481 0.101086 0.0641117 0.0639413 0.103193 0.0381144C0.142275 0.0122875 0.188311 -0.000990099 0.235144 5.75507e-05H1.82514C1.88614 5.75507e-05 1.94465 0.0242896 1.98778 0.067423C2.03091 0.110556 2.05514 0.169058 2.05514 0.230058V1.85006Z",
    transform: "translate(3.95312 5.5)",
    stroke: "#1E334E",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.34 0H0V0.660001H14.34V0Z",
    transform: "translate(7.2793 17.8965) rotate(-45)",
    fill: "#1E334E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentIcon);
export default __webpack_public_path__ + "static/media/Percent_Icon.a366e92308c24d3e7fa091e21e7eb392.svg";
export { ForwardRef as ReactComponent };